const CategoryRoutes = [
  {
    icon: '',
    path: '/categories',
    name: 'Categories',
    component: () => import('@/pages/category/CategoryList.vue'),
    meta: {
      auth: true,
      roles: ['admin', 'super_admin']
    }
  }
];

export default CategoryRoutes;